/**
 * @author Geethananth M
 * Model Object to hold the Basement Categories
 */

/**
 * Model For Basement
 */
export const basementModel = {
  flowName: "basement-flow",
  serviceType: "",
  basementSize: 0, // basement Size in SQFT
  basementHeight: 0,
  requirePlumbing: "",
  requireSumpPump: "",
  requireElectricalInstallation: "",
  addOns: [],
  personalInfo: {
    name: "",
    email: "",
    phoneNumber: "",
    fullAddress: "",
  },
  comments: "",
  costFor: {
    size: 0,
    height: 0,
    plumbing: 0,
    sumpPump: 0,
    electrical: 0,
    addOns: 0,
  },
};
